<template>
  <v-row>
    <!-- <v-col cols="12" md="2">
      <v-img
        lazy-src="https://placehold.co/200x200?text=IMAGE%2001"
        max-height="120"
        max-width="120"
        class="ma-2 card-product"
        src="https://placehold.co/200x200?text=IMAGE%2001"
      ></v-img>
      <v-img
        lazy-src="https://placehold.co/200x200?text=IMAGE%2002"
        max-height="120"
        max-width="120"
        class="ma-2 card-product"
        src="https://placehold.co/200x200?text=IMAGE%2002"
      ></v-img>
      <v-img
        lazy-src="https://placehold.co/200x200?text=IMAGE%2003"
        max-height="120"
        max-width="120"
        class="ma-2 card-product"
        src="https://placehold.co/200x200?text=IMAGE%2003"
      ></v-img>
      <v-img
        lazy-src="https://placehold.co/200x200?text=IMAGE%2004"
        max-height="120"
        max-width="120"
        class="ma-2 card-product"
        src="https://placehold.co/200x200?text=IMAGE%2004"
      ></v-img>
    </v-col> -->
    <v-col cols="12" md="12">
      <v-card class="elevation-0">
        <div class="wrapper-labels">
          <label v-if="productSelected.marketing" class="mkt">MKT</label>
          <label
            v-if="productSelected.opportunity && pageOrigin === 'book'"
            class="opportunity"
          >
            OPORTUNIDADE
          </label>
        </div>
        <div class="wrapper-selos">
          <img
            v-for="selo in productSelected.technologies"
            :key="selo.name"
            class="selo"
            :src="selo.image"
          />
        </div>
        <v-img
          :src="productSelected.image"
          :lazy-src="productSelected.image"
          aspect-ratio="1.7777"
          class="grey lighten-2 image-clickable"
          @click="onClickImage(productSelected.image)"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-card>
      <ImageZoom
        :visible="dialogZoomPhoto"
        :closeDialog="closeDialogZoomPhoto"
        :photo="photoDialogZoom"
        :reference="productSelected.reference"
        :name="productSelected.name"
      />
    </v-col>
  </v-row>
</template>

<script>
import ImageZoom from "@/components/ImageZoom";
export default {
  components: {
    ImageZoom,
  },
  props: {
    productSelected: {},
    pageOrigin: String,
  },
  data: () => ({
    dialogZoomPhoto: false,
    photoDialogZoom: "",
  }),
  methods: {
    onClickImage(image) {
      if (image == "") return;
      this.photoDialogZoom = image;
      this.dialogZoomPhoto = true;
    },
    closeDialogZoomPhoto() {
      this.dialogZoomPhoto = false;
      this.photoDialogZoom = "";
    },
  },
};
</script>

<style scope>
.image-clickable {
  cursor: pointer;
}
.card-product:hover {
  border: 1px solid #ccc;
  cursor: pointer;
}
.wrapper-selos {
  position: absolute;
  display: grid;
  z-index: 3;
  right: 0;
  top: 0;
  width: 60px;
  float: right;
}

.selo {
  width: 60px;
  float: right;
}

.wrapper-labels {
  position: absolute;
  display: grid;
  z-index: 3;
  left: 0;
  top: 0;
  float: left;
}

.mkt {
  font-size: 22px;
  font-weight: bold;
}
.opportunity {
  font-size: 22px;
  font-weight: bold;
  color: red;
}
</style>
